import { render } from "./PanelOptionRadio.vue?vue&type=template&id=6063cf9f&lang=pug"
import script from "./PanelOptionRadio.vue?vue&type=script&lang=js"
export * from "./PanelOptionRadio.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__